import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getNonPendingSystemVendorInvoices = async () => {
  try {
    const response = await apiClient.get('/systemVendorInvoiceManagement/invoice/list-non-pending');
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
